var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-row',[_c('a-col',{attrs:{"span":6}},[_vm._v(" "+_vm._s(_vm.$t( 'clientinfo.password' ))+": ")]),_c('a-col',{attrs:{"span":18}},[_c('password',{attrs:{"password":_vm.SingleCloud.TEMPLATE.CONTEXT.PASSWORD}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }